import { TransactionStatus } from 'enums';
import { useTranslation } from 'react-i18next';

export const getMessageFromStatus = (status) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation();
    switch (status) {
        case TransactionStatus.submitted:
            return t('TransactionSubmitted');
        case TransactionStatus.paid:
            return t('TransactionPaid');
        case TransactionStatus.canceled:
            return t('TransactionCanceled');
        case TransactionStatus.rechecked:
            return t('TransactionRechecked');
        case TransactionStatus.pendingPayment:
            return t('TransactionPendingPayment');
        case TransactionStatus.pending:
            return t('TransactionPending');
        default:
            throw new Error('Invalid status');
    }
};
